import { NUMBER_0 } from "constants/numbers";
import saveLocalCookie from "./saveLocalCookie";
import { IBulkConfig } from "types/config-files/mainConfig";

const deleteLocalCookie = (cookieName: string, bulkConfig: IBulkConfig | null) => {
  return saveLocalCookie(cookieName, "", NUMBER_0, bulkConfig);
}

export default deleteLocalCookie;
